import { getRegistrantUnregisteredPropertiesQueryKey } from "@/hera-api/client/@tanstack/react-query.gen";
import type { QueryClient } from "@tanstack/react-query";

import { refreshLicensesAfterLocalChange } from "./license-details-change-notification";

/** Same key as bulk-payment screen `useQuery` for fee lines. */
export const BULK_PAYMENT_FEES_QUERY_KEY = ["bulkPaymentFees"] as const;

/** Avoid re-running expensive registrant list queries on every tab focus. */
const REGISTRANT_DASHBOARD_LIST_STALE_MS = 60_000;

export const registrantLicensesQueryOptions = {
  staleTime: REGISTRANT_DASHBOARD_LIST_STALE_MS,
  refetchOnWindowFocus: false,
} as const;

/** Avoid re-running expensive bulk-payment-fees on every tab focus. */
export const bulkPaymentFeesQueryOptions = {
  staleTime: REGISTRANT_DASHBOARD_LIST_STALE_MS,
  refetchOnWindowFocus: false,
} as const;

/**
 * Refetch registrant dashboard data after Stripe redirect, payment errors, or
 * manual payment flows so license / bulk-pay / unregistered property lists stay current.
 */
export async function invalidateRegistrantDashboardLists(
  queryClient: QueryClient,
): Promise<void> {
  await refreshLicensesAfterLocalChange(queryClient, []);
  await Promise.all([
    queryClient.invalidateQueries({
      queryKey: [...BULK_PAYMENT_FEES_QUERY_KEY],
    }),
    queryClient.invalidateQueries({
      queryKey: getRegistrantUnregisteredPropertiesQueryKey(),
    }),
  ]);
}
